module.exports = __webpack_public_path__ + "img/right.9e73ea2f.png";